"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberConverter = /** @class */ (function () {
    function NumberConverter() {
    }
    NumberConverter.numberWithMetricAffix = function (number) {
        if (number === undefined || number === null) {
            return number;
        }
        if (number < 0) {
            return "-" + this.numberWithMetricAffix(-number);
        }
        for (var i = 0; i < this.metricRanges.length; i++) {
            var range = this.metricRanges[i];
            if (number >= range.divider) {
                return "" + Math.floor((number / range.divider) * 100) / 100 + range.suffix;
            }
        }
        return "" + number;
    };
    // TODO: find out if suffixes should be translated
    NumberConverter.metricRanges = [
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "k" },
    ];
    return NumberConverter;
}());
exports.default = NumberConverter;
//# sourceMappingURL=NumberConverter.js.map